<template>
	<v-card>
		<v-toolbar flat dense cad>
			<v-toolbar-title class="subheading"> Messages </v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-divider></v-divider>

		<v-card-text>
			<v-list two-line class="flexible-height">
				<v-list-tile v-for="(message, index) in messages" :key="index" @click="onMessageClicked(message)">
					<v-list-tile-avatar>
						<v-icon :color="getIconMeta(message).color">{{getIconMeta(message).icon}}</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-html="message.title"></v-list-tile-title>
						<v-list-tile-sub-title v-html="message.message"></v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		props: {
			messages: {
				type: Array,
				required: true
			}
		},
        methods: {
            getIconMeta(message) {
                switch (message.type) {
                    case 'hrDocumentUpdate':
                        return { icon: 'mdi-cloud-download', color: 'green' };
                }
            },
            onMessageClicked(message) {
                switch (message.type) {
                    case 'hrDocumentUpdate':
                        this.$router.push({ name: 'hrDocument', params: { id: message.id, loadUpdate: true } });
                }
            }
        }
	};
</script>